module.exports = __webpack_public_path__ + "media/src/assets/Images/AboutUsMobileBackground-bb8ce2cebf6f19d0b4edd3bc7c85782b.svg";